(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('soe-categories-carousel')) {
    customElements.define('soe-categories-carousel', class extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
        this.abortController = new AbortController();
        this.track = this.querySelector('[data-soe-categories-track]');
        this.previous = this.querySelector('[data-soe-categories-previous]');
        this.next = this.querySelector('[data-soe-categories-next]');
        if (!this.track) return;

        const options = { signal: this.abortController.signal };
        this.track.addEventListener('scroll', () => this.update(), { passive: true, ...options });
        this.addEventListener('click', (event) => this.handleClick(event), options);
        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.track);
        requestAnimationFrame(() => this.update());
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
      }

      handleClick(event) {
        const button = event.target.closest('[data-soe-categories-previous], [data-soe-categories-next]');
        if (!button || !this.track) return;
        const item = this.track.firstElementChild;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const distance = item ? item.getBoundingClientRect().width + gap : this.track.clientWidth;
        const direction = button.hasAttribute('data-soe-categories-next') ? 1 : -1;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollBy({ left: distance * direction, behavior: reduceMotion ? 'auto' : 'smooth' });
      }

      update() {
        if (!this.track) return;
        const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const atStart = this.track.scrollLeft <= 2;
        const atEnd = this.track.scrollLeft >= maximum - 2;
        const hasOverflow = maximum > 2;

        if (this.previous) {
          this.previous.hidden = !hasOverflow;
          this.previous.disabled = atStart;
          this.previous.setAttribute('aria-disabled', String(atStart));
        }
        if (this.next) {
          this.next.hidden = !hasOverflow;
          this.next.disabled = atEnd;
          this.next.setAttribute('aria-disabled', String(atEnd));
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
  (() => {
    const initialized = new WeakSet();
    const searchControllers = new WeakMap();
    const searchCache = new Map();
    const normalize = (value) => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();

    const initTagSearch = (root) => {
      const input = root.querySelector('[data-tag-search-input]');
      const panel = root.querySelector('[data-tag-suggestions]');
      const clear = root.querySelector('[data-tag-search-clear]');
      const empty = root.querySelector('[data-tag-search-empty]');
      const status = root.querySelector('[data-tag-search-status]');
      const sort = root.querySelector('[data-blog-sort]');
      const articleList = root.querySelector('[data-article-list]');
      const liveEmpty = root.querySelector('[data-live-search-empty]');
      const liveClear = root.querySelector('[data-live-search-clear]');
      const nativeNavigation = [...root.querySelectorAll('[data-blog-pagination], .soe-blog-listing__load-more-wrap')];
      const suggestions = panel ? [...panel.querySelectorAll('[data-tag-suggestion]')] : [];
      if (!input || !panel || !clear || !articleList) return;

      let nativeArticles = articleList.innerHTML;
      let liveMode = false;
      const currentTags = (root.dataset.currentTags || '').split('||').filter(Boolean);
      let timer;

      const close = () => {
        panel.hidden = true;
        input.setAttribute('aria-expanded', 'false');
      };

      const updateSuggestions = () => {
        const query = normalize(input.value);
        let matches = 0;
        suggestions.forEach((suggestion) => {
          const matchesQuery = query && normalize(suggestion.dataset.tagName).includes(query);
          suggestion.hidden = !matchesQuery;
          if (matchesQuery) matches += 1;
        });
        clear.hidden = !input.value;
        empty.hidden = !query || matches > 0;
        panel.hidden = !query;
        input.setAttribute('aria-expanded', query ? 'true' : 'false');
      };

      const toggleNativeNavigation = (visible) => {
        nativeNavigation.forEach((element) => { element.hidden = !visible; });
      };

      const restoreNativeArticles = () => {
        searchControllers.get(root)?.abort();
        articleList.innerHTML = nativeArticles;
        articleList.removeAttribute('aria-busy');
        liveEmpty.hidden = true;
        liveMode = false;
        toggleNativeNavigation(true);
        if (status) status.textContent = 'Se muestran las publicaciones del blog.';
      };

      const collectCardHtml = (container) => [...container.querySelectorAll('[data-article-id]')].map((card) => card.outerHTML);

      const parseCards = (cards) => cards.map((html) => {
        const template = document.createElement('template');
        template.innerHTML = html.trim();
        return template.content.firstElementChild;
      }).filter(Boolean);

      const nativeCardHtml = () => {
        const template = document.createElement('template');
        template.innerHTML = nativeArticles;
        return collectCardHtml(template.content);
      };

      const fetchBlogArticles = async (signal) => {
        const cacheKey = `${root.dataset.blogId}::${currentTags.join('|')}`;
        if (searchCache.has(cacheKey)) return searchCache.get(cacheKey);

        const cards = new Map();
        collectCardHtml(articleList).forEach((html) => {
          const template = document.createElement('template');
          template.innerHTML = html.trim();
          const card = template.content.firstElementChild;
          if (card?.dataset.articleId) cards.set(card.dataset.articleId, html);
        });

        let nextUrl = root.querySelector('[data-blog-next-page]')?.href || '';
        let page = 0;
        while (nextUrl && page < 20) {
          const response = await fetch(nextUrl, { signal, headers: { 'X-Requested-With': 'XMLHttpRequest' } });
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
          const fetchedRoot = parsed.querySelector(`[data-soe-blog-section="${root.dataset.soeBlogSection}"]`);
          if (!fetchedRoot) throw new Error('Missing blog page results');
          fetchedRoot.querySelectorAll('[data-article-id]').forEach((card) => {
            if (card.dataset.articleId) cards.set(card.dataset.articleId, card.outerHTML);
          });
          nextUrl = fetchedRoot.querySelector('[data-blog-next-page]')?.href || '';
          page += 1;
        }

        const result = [...cards.values()];
        searchCache.set(cacheKey, result);
        return result;
      };

      const filterAndSortCards = (cards, term, order) => {
        const words = normalize(term).split(/\s+/).filter(Boolean);
        const matchingCards = parseCards(cards).filter((card) => {
          if (words.length === 0) return true;
          const title = card.querySelector('.soe-blog-listing__article-title')?.textContent || '';
          const description = card.querySelector('.soe-blog-listing__article-excerpt')?.textContent || '';
          const searchableText = normalize(`${title} ${description}`);
          return words.every((word) => searchableText.includes(word));
        });

        matchingCards.sort((first, second) => {
          const firstDate = Number.parseInt(first.dataset.publishedAt, 10) || 0;
          const secondDate = Number.parseInt(second.dataset.publishedAt, 10) || 0;
          return order === 'oldest' ? firstDate - secondDate : secondDate - firstDate;
        });
        return matchingCards;
      };

      const executeSearch = async () => {
        const term = input.value.trim();
        const order = sort?.value || 'newest';
        if (!term && order === 'newest') {
          restoreNativeArticles();
          return;
        }

        if (!liveMode) nativeArticles = articleList.innerHTML;
        liveMode = true;

        searchControllers.get(root)?.abort();
        const controller = new AbortController();
        searchControllers.set(root, controller);
        articleList.setAttribute('aria-busy', 'true');
        liveEmpty.hidden = true;
        toggleNativeNavigation(false);
        if (status) status.textContent = 'Buscando publicaciones...';

        let cards;
        try {
          cards = await fetchBlogArticles(controller.signal);
        } catch (error) {
          if (error.name === 'AbortError') return;
          cards = nativeCardHtml();
        }

        const matchingCards = filterAndSortCards(cards, term, order);
        articleList.replaceChildren(...matchingCards);
        articleList.removeAttribute('aria-busy');
        liveEmpty.hidden = matchingCards.length > 0;
        if (status) status.textContent = `${matchingCards.length} publicaciones encontradas en este blog.`;
      };

      const scheduleSearch = () => {
        window.clearTimeout(timer);
        timer = window.setTimeout(executeSearch, 360);
      };

      input.addEventListener('input', () => {
        updateSuggestions();
        scheduleSearch();
      });
      input.addEventListener('focus', updateSuggestions);
      input.addEventListener('blur', () => window.setTimeout(close, 120));
      input.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          close();
          return;
        }
        if (event.key !== 'Enter') return;
        event.preventDefault();
        window.clearTimeout(timer);
        close();
        executeSearch();
      });

      clear.addEventListener('click', () => {
        input.value = '';
        updateSuggestions();
        executeSearch();
        input.focus();
      });

      liveClear?.addEventListener('click', () => {
        input.value = '';
        if (sort) sort.value = 'newest';
        updateSuggestions();
        restoreNativeArticles();
        input.focus();
      });

      sort?.addEventListener('change', executeSearch);

    };

    const initMoreTags = (root) => {
      const button = root.querySelector('[data-tags-more]');
      if (!button) return;
      button.addEventListener('click', () => {
        const expanded = button.getAttribute('aria-expanded') === 'true';
        root.querySelectorAll('[data-extra-tag]').forEach((tag) => { tag.hidden = expanded; });
        button.setAttribute('aria-expanded', String(!expanded));
        button.textContent = expanded ? button.dataset.moreLabel : button.dataset.lessLabel;
      });
    };

    const initLoadMore = (root) => {
      const button = root.querySelector('[data-load-more]');
      const list = root.querySelector('[data-article-list]');
      const status = root.querySelector('[data-load-more-status]');
      if (!button || !list) return;

      button.addEventListener('click', async () => {
        const nextUrl = button.dataset.nextUrl;
        if (!nextUrl || button.getAttribute('aria-busy') === 'true') return;
        const originalLabel = button.querySelector('span')?.textContent || '';
        button.setAttribute('aria-busy', 'true');
        if (button.querySelector('span')) button.querySelector('span').textContent = button.dataset.loadingLabel;

        try {
          const response = await fetch(nextUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
          const fetchedRoot = documentFragment.querySelector(`[data-soe-blog-section="${root.dataset.soeBlogSection}"]`);
          const fetchedList = fetchedRoot?.querySelector('[data-article-list]');
          if (!fetchedList) throw new Error('Missing article list');

          const existingIds = new Set([...list.querySelectorAll('[data-article-id]')].map((card) => card.dataset.articleId));
          [...fetchedList.children].forEach((card) => {
            if (!existingIds.has(card.dataset.articleId)) list.appendChild(card);
          });

          const fetchedButton = fetchedRoot.querySelector('[data-load-more]');
          if (fetchedButton?.dataset.nextUrl) {
            button.dataset.nextUrl = fetchedButton.dataset.nextUrl;
            button.removeAttribute('aria-busy');
            if (button.querySelector('span')) button.querySelector('span').textContent = originalLabel;
          } else {
            button.closest('.soe-blog-listing__load-more-wrap')?.remove();
          }
          if (status) status.textContent = 'Se cargaron más publicaciones.';
        } catch (error) {
          button.removeAttribute('aria-busy');
          if (button.querySelector('span')) button.querySelector('span').textContent = originalLabel;
          if (status) status.textContent = 'No fue posible cargar más publicaciones. Inténtalo de nuevo.';
        }
      });
    };

    const init = (root) => {
      if (initialized.has(root)) return;
      initialized.add(root);
      root.classList.add('is-js');
      initTagSearch(root);
      initMoreTags(root);
      initLoadMore(root);
    };

    const initAll = (scope = document) => scope.querySelectorAll('[data-soe-blog-section]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
    else initAll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  (() => {
    if (window.__soeCartUiInitialized) return;
    window.__soeCartUiInitialized = true;

    const updateNoteCount = (textarea) => {
      const root = textarea.closest('.soe-cart__note');
      const count = root?.querySelector('[data-soe-cart-note-count]');
      if (count) count.textContent = textarea.value.length;
    };

    document.addEventListener('input', (event) => {
      if (event.target.matches('[data-soe-cart-note]')) updateNoteCount(event.target);
    });

    document.addEventListener('submit', (event) => {
      if (event.target.id !== 'cart' || event.submitter?.name !== 'checkout') return;
      event.submitter.setAttribute('aria-busy', 'true');
    });

    document.querySelectorAll('[data-soe-cart-note]').forEach(updateNoteCount);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (() => {
    const initialized = new WeakSet();

    const initTabs = (root) => {
      if (!root || initialized.has(root)) return;
      initialized.add(root);
      const tabs = Array.from(root.querySelectorAll('[role="tab"]'));
      const panels = Array.from(root.querySelectorAll('[role="tabpanel"]'));
      if (!tabs.length) return;

      const activate = (tab, focus = false) => {
        tabs.forEach((item) => {
          const active = item === tab;
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
        });
        panels.forEach((panel) => {
          panel.hidden = panel.id !== tab.getAttribute('aria-controls');
        });
        if (focus) tab.focus();
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', (event) => {
          let nextIndex = null;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;
          if (nextIndex === null) return;
          event.preventDefault();
          activate(tabs[nextIndex], true);
        });
      });
    };

    const initAll = (scope = document) => {
      scope.querySelectorAll('[data-soe-product-tabs]').forEach(initTabs);
    };

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["soe-blog-hub"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('soe-blog-hub')) {
    customElements.define('soe-blog-hub', class extends HTMLElement {
      connectedCallback() {
        this.links = [...this.querySelectorAll('[data-blog-nav-link]')];
        this.categories = [...this.querySelectorAll('[data-blog-category]')];
        this.handleClick = this.handleClick.bind(this);
        this.links.forEach((link) => link.addEventListener('click', this.handleClick));

        if ('IntersectionObserver' in window && this.links.length && this.categories.length) {
          this.observer = new IntersectionObserver((entries) => {
            const visible = entries
              .filter((entry) => entry.isIntersecting)
              .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
            if (visible) this.setActive(visible.target.id);
          }, { rootMargin: '-18% 0px -68% 0px', threshold: [0, .15, .5] });
          this.categories.forEach((category) => this.observer.observe(category));
        }
      }

      disconnectedCallback() {
        this.links?.forEach((link) => link.removeEventListener('click', this.handleClick));
        this.observer?.disconnect();
      }

      handleClick(event) {
        const id = event.currentTarget.hash.slice(1);
        const target = this.querySelector(`#${CSS.escape(id)}`);
        if (!target) return;
        this.setActive(id);
        if (this.dataset.smoothScroll === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          event.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          history.replaceState(null, '', `#${id}`);
        }
      }

      setActive(id) {
        this.links.forEach((link) => {
          const active = link.hash === `#${id}`;
          link.classList.toggle('is-active', active);
          if (active) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["soe-category-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('soe-category-carousel')) {
    customElements.define(
      'soe-category-carousel',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.soe-category-carousel__track');
          this.previousButton = this.querySelector('[data-carousel-previous]');
          this.nextButton = this.querySelector('[data-carousel-next]');
          if (!this.track) return;

          this.abortController = new AbortController();
          const signal = this.abortController.signal;

          this.previousButton?.addEventListener('click', () => this.move(-1), { signal });
          this.nextButton?.addEventListener('click', () => this.move(1), { signal });
          this.track.addEventListener('scroll', () => this.requestUpdate(), { passive: true, signal });
          this.track.addEventListener('keydown', (event) => this.onKeydown(event), { signal });
          this.track.addEventListener('pointerdown', (event) => this.onPointerDown(event), { signal });
          this.track.addEventListener('pointermove', (event) => this.onPointerMove(event), { signal });
          this.track.addEventListener('pointerup', (event) => this.onPointerUp(event), { signal });
          this.track.addEventListener('pointercancel', (event) => this.onPointerUp(event), { signal });
          this.track.addEventListener('click', (event) => this.onClick(event), { capture: true, signal });

          this.resizeObserver = new ResizeObserver(() => this.update());
          this.resizeObserver.observe(this.track);
          requestAnimationFrame(() => this.update());
        }

        disconnectedCallback() {
          this.abortController?.abort();
          this.resizeObserver?.disconnect();
        }

        get step() {
          const items = this.track.querySelectorAll('.soe-category-carousel__item');
          if (!items.length) return this.track.clientWidth;
          if (items.length === 1) return items[0].offsetWidth;
          return items[1].offsetLeft - items[0].offsetLeft;
        }

        move(direction) {
          this.track.scrollBy({ left: direction * this.step, behavior: 'smooth' });
        }

        onKeydown(event) {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.move(event.key === 'ArrowRight' ? 1 : -1);
        }

        onPointerDown(event) {
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          this.isDragging = true;
          this.hasDragged = false;
          this.dragStartX = event.clientX;
          this.dragStartScroll = this.track.scrollLeft;
          this.track.setPointerCapture(event.pointerId);
          this.track.classList.add('is-dragging');
        }

        onPointerMove(event) {
          if (!this.isDragging) return;
          const distance = event.clientX - this.dragStartX;
          if (Math.abs(distance) > 5) this.hasDragged = true;
          this.track.scrollLeft = this.dragStartScroll - distance;
        }

        onPointerUp(event) {
          if (!this.isDragging) return;
          this.isDragging = false;
          this.track.classList.remove('is-dragging');
          if (this.track.hasPointerCapture(event.pointerId)) this.track.releasePointerCapture(event.pointerId);
          if (this.hasDragged) this.dragFinishedAt = performance.now();
        }

        onClick(event) {
          if (this.dragFinishedAt && performance.now() - this.dragFinishedAt < 220) {
            event.preventDefault();
            event.stopPropagation();
          }
        }

        requestUpdate() {
          if (this.updateFrame) return;
          this.updateFrame = requestAnimationFrame(() => {
            this.updateFrame = null;
            this.update();
          });
        }

        update() {
          const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
          const overflowing = maximum > 2;
          this.dataset.overflowing = overflowing.toString();
          if (this.previousButton) this.previousButton.disabled = !overflowing || this.track.scrollLeft <= 2;
          if (this.nextButton) this.nextButton.disabled = !overflowing || this.track.scrollLeft >= maximum - 2;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["soe-collections-featured-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('soe-showcase')) {
    customElements.define(
      'soe-showcase',
      class SoeShowcase extends HTMLElement {
        connectedCallback() {
          this.abortController?.abort();
          this.resizeObserver?.disconnect();
          this.abortController = new AbortController();
          this.tracks = new Map();
          this.resizeObserver = new ResizeObserver(() => this.updateAll());

          this.querySelectorAll('[data-soe-track]').forEach((track) => {
            const key = track.dataset.soeTrack;
            const previous = this.querySelector(`[data-soe-prev="${key}"]`);
            const next = this.querySelector(`[data-soe-next="${key}"]`);
            this.tracks.set(key, { track, previous, next });
            track.addEventListener('scroll', () => this.update(key), {
              passive: true,
              signal: this.abortController.signal,
            });
            this.resizeObserver.observe(track);
          });

          this.addEventListener('click', this.handleClick, { signal: this.abortController.signal });
          requestAnimationFrame(() => this.updateAll());
        }

        disconnectedCallback() {
          this.abortController?.abort();
          this.resizeObserver?.disconnect();
        }

        handleClick = (event) => {
          const button = event.target.closest('[data-soe-prev], [data-soe-next]');
          if (!button || !this.contains(button)) return;
          const key = button.dataset.soePrev || button.dataset.soeNext;
          const state = this.tracks.get(key);
          if (!state) return;
          const item = state.track.firstElementChild;
          const gap = parseFloat(getComputedStyle(state.track).columnGap) || 0;
          const distance = item ? item.getBoundingClientRect().width + gap : state.track.clientWidth;
          const direction = button.hasAttribute('data-soe-next') ? 1 : -1;
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          state.track.scrollBy({ left: distance * direction, behavior: reduceMotion ? 'auto' : 'smooth' });
        };

        updateAll() {
          this.tracks.forEach((value, key) => this.update(key));
        }

        update(key) {
          const state = this.tracks.get(key);
          if (!state) return;
          const maximum = Math.max(0, state.track.scrollWidth - state.track.clientWidth);
          const atStart = state.track.scrollLeft <= 2;
          const atEnd = state.track.scrollLeft >= maximum - 2;
          const hasOverflow = maximum > 2;

          if (state.previous) {
            state.previous.hidden = !hasOverflow;
            state.previous.disabled = atStart;
            state.previous.setAttribute('aria-disabled', String(atStart));
          }
          if (state.next) {
            state.next.hidden = !hasOverflow;
            state.next.disabled = atEnd;
            state.next.setAttribute('aria-disabled', String(atEnd));
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["soe-community-social"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('soe-community-carousel')) {
    customElements.define('soe-community-carousel', class extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
        this.abortController = new AbortController();
        this.track = this.querySelector('[data-community-track]');
        this.previous = this.querySelector('[data-community-prev]');
        this.next = this.querySelector('[data-community-next]');
        if (!this.track) return;

        const options = { signal: this.abortController.signal };
        this.track.addEventListener('scroll', () => this.update(), { passive: true, ...options });
        this.addEventListener('click', (event) => this.handleClick(event), options);
        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.track);
        requestAnimationFrame(() => this.update());
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
      }

      handleClick(event) {
        const button = event.target.closest('[data-community-prev], [data-community-next]');
        if (!button || !this.track) return;
        const item = this.track.firstElementChild;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const distance = item ? item.getBoundingClientRect().width + gap : this.track.clientWidth;
        const direction = button.hasAttribute('data-community-next') ? 1 : -1;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollBy({ left: distance * direction, behavior: reduceMotion ? 'auto' : 'smooth' });
      }

      update() {
        if (!this.track) return;
        const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const atStart = this.track.scrollLeft <= 2;
        const atEnd = this.track.scrollLeft >= maximum - 2;
        const hasOverflow = maximum > 2;

        if (this.previous) {
          this.previous.hidden = !hasOverflow;
          this.previous.disabled = atStart;
          this.previous.setAttribute('aria-disabled', String(atStart));
        }
        if (this.next) {
          this.next.hidden = !hasOverflow;
          this.next.disabled = atEnd;
          this.next.setAttribute('aria-disabled', String(atEnd));
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["soe-contact-page"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('soe-contact-page')) {
    customElements.define('soe-contact-page', class extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        this.status = this.querySelector('[data-soe-inbox-status]');
        this.subject = this.querySelector('[data-soe-contact-subject]');
        const options = { signal: this.abortController.signal };
        this.addEventListener('click', (event) => this.handleQuickHelp(event), options);
        this.restoreSubject();
        this.subject?.addEventListener('change', () => this.saveSubject(), options);
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      get storageKey() {
        return `soe-contact-subject-${this.id}`;
      }

      restoreSubject() {
        if (!this.subject) return;
        try {
          const value = sessionStorage.getItem(this.storageKey);
          if (value && Array.from(this.subject.options).some((option) => option.value === value)) this.subject.value = value;
        } catch (error) {
          return;
        }
      }

      saveSubject() {
        try {
          sessionStorage.setItem(this.storageKey, this.subject?.value || '');
        } catch (error) {
          return;
        }
      }

      async handleQuickHelp(event) {
        const button = event.target.closest('[data-soe-inbox-message]');
        if (!button || !this.contains(button)) return;

        const message = button.dataset.soeInboxMessage || button.textContent.trim();
        this.querySelectorAll('[data-soe-inbox-message]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));

        try {
          sessionStorage.setItem('soe-inbox-selected-context', message);
          await navigator.clipboard?.writeText(message);
        } catch (error) {
          try {
            sessionStorage.setItem('soe-inbox-selected-context', message);
          } catch (storageError) {
            this.dataset.storageUnavailable = 'true';
          }
        }

        const opened = this.dataset.useInbox === 'true' && this.openInboxLauncher();
        if (this.status) {
          const fallback = this.dataset.inboxFallback || '';
          this.status.textContent = opened ? `Tema seleccionado: ${message}` : `Tema seleccionado: ${message}. ${fallback}`;
        }
      }

      openInboxLauncher() {
        const selectors = [
          '#ShopifyChat button',
          '#shopify-chat button',
          '[id*="shopify-chat" i] button',
          '[class*="shopify-chat" i] button',
          'button[aria-label*="chat" i]',
          'button[aria-label*="mensaje" i]',
          'button[aria-label*="ayuda" i]',
          '[role="button"][aria-label*="chat" i]'
        ];

        const roots = [document];
        for (let index = 0; index < roots.length; index += 1) {
          const root = roots[index];
          for (const selector of selectors) {
            const launcher = Array.from(root.querySelectorAll(selector)).find((item) => !this.contains(item) && !item.disabled);
            if (launcher) {
              launcher.click();
              return true;
            }
          }
          root.querySelectorAll('*').forEach((element) => {
            if (element.shadowRoot) roots.push(element.shadowRoot);
          });
        }
        return false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["soe-featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('soe-featured-product')) {
    customElements.define('soe-featured-product', class extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };

        this.addEventListener('click', (event) => {
          const zoomTrigger = event.target.closest('[data-open-zoom]');
          if (zoomTrigger) this.openZoom(zoomTrigger);

          const closeZoom = event.target.closest('[data-close-zoom]');
          if (closeZoom) this.closeZoom();

          const dialog = event.target.closest('[data-image-dialog]');
          if (dialog && event.target === dialog) this.closeZoom();

          const thumbnail = event.target.closest('[data-thumbnail]');
          if (thumbnail) this.selectMedia(thumbnail);

          const minus = event.target.closest('[data-quantity-minus]');
          const plus = event.target.closest('[data-quantity-plus]');
          if (minus || plus) this.changeQuantity(plus ? 1 : -1);
        }, options);

        this.querySelector('[data-variant-select]')?.addEventListener('change', (event) => {
          this.updateVariant(event.currentTarget.selectedOptions[0]);
        }, options);

        this.querySelector('[data-image-dialog]')?.addEventListener('close', () => {
          document.body.classList.remove('soe-featured-product-zoom-open');
        }, options);
      }

      disconnectedCallback() {
        this.closeZoom();
        this.abortController?.abort();
      }

      openZoom(trigger) {
        const dialog = this.querySelector('[data-image-dialog]');
        const image = dialog?.querySelector('[data-zoom-image]');
        if (!dialog || !image || !trigger.dataset.zoomSrc) return;
        image.src = trigger.dataset.zoomSrc;
        image.alt = trigger.dataset.zoomAlt || '';
        image.width = Number(trigger.dataset.zoomWidth) || 2000;
        image.height = Number(trigger.dataset.zoomHeight) || 2000;
        if (!dialog.open) dialog.showModal();
        document.body.classList.add('soe-featured-product-zoom-open');
      }

      closeZoom() {
        const dialog = this.querySelector('[data-image-dialog]');
        if (dialog?.open) dialog.close();
        document.body.classList.remove('soe-featured-product-zoom-open');
      }

      selectMedia(thumbnail) {
        const mediaId = thumbnail.dataset.thumbnail;
        this.querySelectorAll('[data-media-slide]').forEach((slide) => {
          slide.hidden = slide.dataset.mediaSlide !== mediaId;
        });
        this.querySelectorAll('[data-thumbnail]').forEach((item) => {
          const active = item === thumbnail;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      }

      changeQuantity(direction) {
        const input = this.querySelector('input[name="quantity"]');
        if (!input) return;
        const min = Number(input.min || 1);
        const max = input.max ? Number(input.max) : Infinity;
        const step = Number(input.step || 1);
        const current = Number(input.value || min);
        input.value = String(Math.min(max, Math.max(min, current + (step * direction))));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      updateVariant(option) {
        if (!option) return;
        const available = option.dataset.available === 'true';
        const price = this.querySelector('[data-price]');
        const comparePrice = this.querySelector('[data-compare-price]');
        const addButton = this.querySelector('[data-add-button]');
        const addButtonText = this.querySelector('[data-add-button-text]');
        const quantity = this.querySelector('input[name="quantity"]');

        if (price) price.textContent = option.dataset.price || '';
        if (comparePrice) {
          comparePrice.textContent = option.dataset.compare || '';
          comparePrice.hidden = option.dataset.showCompare !== 'true';
        }
        if (addButton) addButton.disabled = !available;
        if (addButtonText && addButton) {
          addButtonText.textContent = available ? addButton.dataset.availableLabel : addButton.dataset.soldOutLabel;
        }
        if (quantity) {
          const min = option.dataset.min || '1';
          quantity.min = min;
          quantity.step = option.dataset.step || '1';
          quantity.value = min;
          if (option.dataset.max) quantity.max = option.dataset.max;
          else quantity.removeAttribute('max');
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["soe-main-article"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('soe-main-article')) {
    class SoeMainArticle extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        this.cleanupCallbacks = [];
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.setupActions();
        this.setupCarousels();
      }

      disconnectedCallback() {
        if (this.cleanupCallbacks) this.cleanupCallbacks.forEach((cleanup) => cleanup());
      }

      setupActions() {
        const shareButton = this.querySelector('[data-soe-share]');
        const saveButton = this.querySelector('[data-soe-save]');
        if (shareButton) shareButton.addEventListener('click', () => this.shareArticle());
        if (saveButton) {
          this.updateSavedState(saveButton);
          saveButton.addEventListener('click', () => this.toggleSavedArticle(saveButton));
        }
      }

      async shareArticle() {
        try {
          if (navigator.share) {
            await navigator.share({ title: this.dataset.title, url: this.dataset.url });
          } else {
            await this.copyText(this.dataset.url);
          }
          this.announce(this.dataset.shareSuccess);
        } catch (error) {
          if (error.name !== 'AbortError') this.announce(this.dataset.shareError);
        }
      }

      async copyText(value) {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(value);
          return;
        }
        const field = document.createElement('textarea');
        field.value = value;
        field.setAttribute('readonly', '');
        field.style.position = 'fixed';
        field.style.opacity = '0';
        document.body.append(field);
        field.select();
        document.execCommand('copy');
        field.remove();
      }

      getSavedArticles() {
        try {
          const saved = JSON.parse(localStorage.getItem('soeSavedArticles') || '[]');
          return Array.isArray(saved) ? saved : [];
        } catch (error) {
          return [];
        }
      }

      updateSavedState(button) {
        const isSaved = this.getSavedArticles().some((item) => item.url === this.dataset.url);
        button.setAttribute('aria-pressed', String(isSaved));
        const label = button.querySelector('[data-soe-save-label]');
        const savedLabel = button.querySelector('[data-soe-saved-label]');
        if (label && !label.dataset.defaultLabel) label.dataset.defaultLabel = label.textContent.trim();
        if (label && savedLabel) label.textContent = isSaved ? savedLabel.textContent.trim() : label.dataset.defaultLabel;
      }

      toggleSavedArticle(button) {
        try {
          const saved = this.getSavedArticles();
          const index = saved.findIndex((item) => item.url === this.dataset.url);
          if (index >= 0) saved.splice(index, 1);
          else saved.push({ title: this.dataset.title, url: this.dataset.url });
          localStorage.setItem('soeSavedArticles', JSON.stringify(saved));
          this.updateSavedState(button);
          this.announce(this.dataset.saveSuccess);
        } catch (error) {
          this.announce(this.dataset.saveError);
        }
      }

      announce(message) {
        const status = this.querySelector('[data-soe-action-status]');
        if (!status) return;
        status.textContent = '';
        window.requestAnimationFrame(() => {
          status.textContent = message;
        });
      }

      setupCarousels() {
        this.querySelectorAll('[data-soe-carousel-track]').forEach((track) => {
          const name = track.dataset.soeCarouselTrack;
          const buttons = [...this.querySelectorAll(`[data-soe-carousel-button="${name}"]`)];
          const update = () => {
            const maxScroll = track.scrollWidth - track.clientWidth;
            buttons.forEach((button) => {
              button.hidden = maxScroll <= 2;
              button.disabled = Number(button.dataset.direction) < 0 ? track.scrollLeft <= 2 : track.scrollLeft >= maxScroll - 2;
            });
          };
          buttons.forEach((button) => {
            button.addEventListener('click', () => {
              track.scrollBy({ left: Number(button.dataset.direction) * Math.max(track.clientWidth * .82, 260), behavior: this.reducedMotion.matches ? 'auto' : 'smooth' });
            });
          });
          track.addEventListener('scroll', update, { passive: true });
          window.addEventListener('resize', update, { passive: true });
          this.cleanupCallbacks.push(() => window.removeEventListener('resize', update));
          update();
        });
      }
    }

    customElements.define('soe-main-article', SoeMainArticle);
  }

  } catch(e) { console.error(e); }
})();
})();
